import moment from 'moment-timezone';
import {environment} from "environments";

(() => {
  class CancelledVisitListController {

    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Orders) {
      Object.assign(this, {
        $rootScope,
        $scope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Orders
      });
    }

    BOD_2424 = ['localhost'].includes(environment.constants.ENV);

    formatDate(iso_date) {
      if (!iso_date) return null;
      const formatted_date = moment.tz(iso_date, this.timezone).format('DD/MMM/YY h:mm A');
      return formatted_date;
    }

    openPhoneCallModal(cancelledOrder, type) {
      this.callTokboxPhoneCallModal(cancelledOrder, type);
    }

    callTokboxPhoneCallModal(cancelledOrder, type) {
      if (this.$rootScope.phoneCallDialogs === undefined) this.$rootScope.phoneCallDialogs = {};
      var orderId = cancelledOrder.order_id.toString();

      if (this.$rootScope.phoneCallDialogs[orderId] && this.ngDialog.isOpen(this.$rootScope.phoneCallDialogs[orderId].id)) {
        // Dialog is already open
      } else {
        let visit = {};
        visit.id = cancelledOrder.order_id;
        let patient = {};
        let pharmacy = {};
        let data = {};

        if (type === "patient") {
          patient.cell = cancelledOrder.patient.phone;
          patient.firstname = cancelledOrder.patient.firstname;
          patient.lastname = cancelledOrder.patient.lastname;
          data = {
            patient: patient,
            visit: visit,
            pharmacy: {}
          };
        } else {
          pharmacy.cell = cancelledOrder.pharmacy.phone;
          pharmacy.name = cancelledOrder.pharmacy.name;
          data = {
            patient: {},
            visit: visit,
            pharmacy: pharmacy
          };
        }

        this.$rootScope.phoneCallDialogs[orderId] = this.ngDialog.open({
          templateUrl: 'app/components/tokbox/tokbox-phonecall-modal.html',
          // To make possible doctor still be able to use the screen behind
          overlay: false,
          // To not allow the user closes the modal without explicitely to have some action
          showClose: false,
          closeByEscape: false,
          closeByNavigation: false,
          closeByDocument: false,
          controller: 'TokboxPhoneCallController',
          controllerAs: 'tokbox',
          className: 'ngdialog-theme-default tokbox-phonecall-modal',
          data: data
        });
      }
    }

    showDetails(order) {
      if (!this.BOD_2424) {
        this.openChangeStoreOrder(order, response => {
          if (response && response.success) {
            // Details updated
            // We need to refresh the list
            this.$rootScope.$broadcast('visit:refresh');
          } else {
            // User closed the popup
            // Do nothing
          }
        });
      }
    }

    changeStoreOrder(order) {
      if (!this.BOD_2424) {
        this.openChangeStoreOrder(order, response => {
          if (response && response != '$closeButton') {
            this.Orders.changeStoreOrder(order.order_id, order.dispense_order_id, response)
              .then(() => {
                this.toastr.success('Store was changed successfully.');
              })
              .catch((err) => {
                let error = "";
                if (err && err.data && err.data.message && err.data.message.summary) {
                  error = err.data.message.summary;
                } else if (err.data.error_message) {
                  error = err.data.error_message;
                }
                this.toastr.error('Error changing store' + (error ? (': ' + error) : '.'));
              });
          } else {
            // Do nothing
            // If user closes the popup
          }
        });
      }
    }

    openChangeStoreOrder(order, callback) {
      if (!this.BOD_2424) {
        return this.ngDialog.open({
          template: 'app/components/change-store-order/change-store-order.html',
          controller: 'ChangeStoreOrderController',
          controllerAs: '$ctrl',
          className: 'ngdialog-theme-default lemonaid-pharmacy-form-modal',
          data: {
            order
          },

          /**
           * @param {string|object} res - res will be an object if a pharmacy is selected
           */
          preCloseCallback(res) {
            if (typeof res === 'object') {
              return callback(res);
            }
            return callback(false);
          },
        });
      }
    }

    getStatusColorForColumbusId(dispensing_status, o2dReceived) {
      switch (true) {
        case ['Completed', 'Printed'].includes(dispensing_status): return 'color-warning'; // orange - ORDER_COMPLETED
        case dispensing_status === 'Collected': return 'color-success'; // green - ORDER_COLLECTED
        case dispensing_status?.startsWith('Cancelled'): return 'color-alert'; // red - ORDER_CANCELLED
        case dispensing_status === 'New' && !!o2dReceived: return 'color-submitted'; // purple - ORDER_SUBMITTED
        default: return 'color-gray-md';
      }
    }

    getDispensingStatusLabel(dispensing_status, o2dReceived){
      return (dispensing_status.toLowerCase() === 'new' && !!o2dReceived) ? 'Sent to Columbus' : dispensing_status;
    }
  }


  CancelledVisitListController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Orders"];
  angular.module('pims').component('cancelledVisitsTable', {
    templateUrl: 'app/components/cancelled-visits-table/cancelled-visits-table.html',
    controller: CancelledVisitListController,
    bindings: {
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      results: '<',
      profile: '<',
      timezone: '='
    }
  });
})();
